var map = {
	"./en/00.intro.md": 1052,
	"./en/01.psychometry.md": 1053,
	"./en/02.why_test.md": 1054,
	"./en/03.interpret.md": 1055,
	"./en/04.communicate.md": 1056,
	"./en/05.remember.md": 1057,
	"./en/06.job_analysis.md": 1058,
	"./nb/00.intro.md": 1059,
	"./nb/01.personlighetstesten.md": 1060,
	"./nb/02.evnetesten.md": 1061,
	"./nb/03.hvorfor_teste.md": 1062,
	"./nb/04.jobbanalyse.md": 1063,
	"./nb/05.tolkning.md": 1064,
	"./nb/06.kommunisere.md": 1065,
	"./nb/07.husk.md": 1066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1051;